import {ethers} from "ethers";
import { PriceKeeperABI } from "./abi/PriceKeeperABI";
import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";

export class PriceKeeperContract extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, PriceKeeperABI.GetABI(), provider);
    }

    async getPrice(): Promise<string>
    {
        return this._toDecimal(await this._call("getPrice", "1000000000000000000"));
    }

    async getCorrectionIndex(): Promise<string>
    {
        return this._toDecimal(await this._call("getCorrectionIndex"));       
    }
    async setCorrectionIndex(corIndex:Number)
    {
        const wei  =this._toWei(corIndex+"");
        const res = this._send("setCorrectionIndex", wei);       
        return res;
    }

    async getQuoteToken(): Promise<string>
    {
        return this._call("getQuoteToken");
    }
}